import { render, staticRenderFns } from "./liquorProduct.vue?vue&type=template&id=1f5e3b6c&scoped=true"
import script from "./liquorProduct.vue?vue&type=script&lang=js"
export * from "./liquorProduct.vue?vue&type=script&lang=js"
import style0 from "./liquorProduct.vue?vue&type=style&index=0&id=1f5e3b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e3b6c",
  null
  
)

export default component.exports